export default __webpack_public_path__ + "static/media/calculator.3acf625f.png";